var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter",
    clipPath: "url(#clip0_57_2157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.543945 34.8467C0.543945 16.069 15.7663 0.84668 34.5439 0.84668C53.3217 0.84668 68.5439 16.069 68.5439 34.8467C68.5439 53.6245 53.3217 68.8467 34.5439 68.8467C15.7663 68.8467 0.543945 53.6245 0.543945 34.8467Z",
    fill: "#55ACEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.5256 28.4825L33.597 29.6589L32.4079 29.5148C28.0795 28.9627 24.298 27.0899 21.0875 23.9445L19.5179 22.3839L19.1136 23.5365C18.2574 26.1054 18.8044 28.8186 20.5881 30.6434C21.5394 31.6517 21.3253 31.7958 19.6844 31.1957C19.1136 31.0036 18.6142 30.8595 18.5666 30.9315C18.4001 31.0996 18.9709 33.2843 19.4227 34.1488C20.0411 35.3492 21.3015 36.5258 22.6809 37.2219L23.8463 37.7742L22.4669 37.7982C21.1351 37.7982 21.0875 37.8223 21.2302 38.3265C21.7058 39.8871 23.5847 41.5438 25.6776 42.2639L27.1519 42.7682L25.8678 43.5366C23.9653 44.641 21.7296 45.2653 19.4941 45.3133C18.4239 45.3373 17.5439 45.4334 17.5439 45.5054C17.5439 45.7455 20.4454 47.09 22.1339 47.6183C27.1995 49.1789 33.2165 48.5065 37.7351 45.8416C40.9457 43.9448 44.1564 40.1753 45.6547 36.5258C46.4633 34.581 47.2718 31.0276 47.2718 29.3229C47.2718 28.2183 47.3432 28.0742 48.675 26.7538C49.4597 25.9854 50.1971 25.1451 50.3397 24.905C50.5775 24.4488 50.5537 24.4488 49.341 24.857C47.3194 25.5774 47.0341 25.4813 48.0328 24.4008C48.7702 23.6326 49.6501 22.2398 49.6501 21.8318C49.6501 21.7597 49.2934 21.8798 48.889 22.0959C48.461 22.3359 47.5096 22.6961 46.7963 22.9122L45.5119 23.3204L44.3466 22.528C43.7044 22.0959 42.8008 21.6157 42.3251 21.4716C41.1121 21.1355 39.2572 21.1835 38.1632 21.5676C35.1904 22.6481 33.3117 25.4333 33.5256 28.4825Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_2157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white",
    transform: "translate(0.543945 0.84668)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.140844202568e0f3766c1b13d0629fba.svg";
export { ForwardRef as ReactComponent };